import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  HostBinding,
  ViewChild,
  TemplateRef,
  NgZone,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
  Optional,
  Injector,
  OnDestroy,
  Inject,
  Renderer2,
} from "@angular/core";
import { NotifyService, NotifyOptions } from "@farris/ui-notify";
import { BsModalService } from "@farris/ui-modal";
import {
  FFileUploadAPIService,
  FFileUploaderService,
  FPreviewEditorService,
} from "../../service/index";
import { FFileSelectDirective } from "../../directive/index";
import { MultiDownloadInfoComponent } from "../multi-download-info/multi-download-info.component";
import {
  UploadOutput,
  UploadInput,
  UploadFile,
  UploaderOptions,
  FUploadFileExtend,
  DocMetaProperty,
  UploadStatus,
  ColumnData
} from "../../model/index";
import { Observable, Subject, Subscription } from "rxjs";
import { FFileUtils } from "../../utils/index";
import {
  trigger,
  style,
  state,
  animate,
  transition,
} from "@angular/animations";

import ResizeObserver from "resize-observer-polyfill";
import { LocaleService } from "@farris/ui-locale";
import { DateTimeHelperService } from "@farris/ui-common/date";
import { WEBAPI_PREFIX_TOKEN } from "@farris/ui-common";
import { take } from "rxjs/operators";
import { PaginationControlsComponent } from "@farris/ui-pagination";

export type CanEditableFn = (fileInfo: any) => boolean;
export type FileCanEditable = CanEditableFn | boolean;
export enum DocModeType {
  Normal = "normal", //默认模式，不开启修订模式，隐藏标记
  RevisionOnly = "revisionOnly", //仅修订模式，开启修订模式，但是用户不可接受或拒绝修订、不可接受所有修订
  Admin = "admin", //开启修订，用户可接受或拒绝修订、可接受所有修订
}
export enum ButtonDisabledAction {
  Edit = "edit",
  Preview = "preview",
  Download = "download",
  Delete = "delete",
}
@Component({
  selector: "f-file-upload-and-preview",
  templateUrl: "./upload-and-preview.component.html",
  styleUrls: ["./upload-and-preview.component.css"],
  providers: [FFileUploaderService, FPreviewEditorService],
  animations: [
    trigger("hideUploaded", [
      state("show", style({ opacity: 1, height: "*" })),
      state("hide", style({ opacity: 0, height: 0 })),
      // transition('* => void', [
      //   style({ opacity: 1}),
      //   animate(200, style({ opacity: 0}))
      // ])
      transition("* => hide", animate("0.5s")),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class UploadAndPreviewComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @HostBinding("class.ffileUploadAndPreview") cls = true;
  @HostBinding("class.ffileUploadAndPreview-content-fill") get fillState() {
    return this.contentFill||this.pagination;
  }
  @HostBinding("class.ffileUploadAndPreview-pagination") get paginationState() {
    return this.pagination;
  }
  // 预览模板
  @ViewChild("previewFileNameTmpl") previewFileNameTmpl: TemplateRef<void>;
  // 文件大小模板
  @ViewChild("fileSizeTmpl") fileSizeTmpl: TemplateRef<void>;
  // 文件状态模板
  @ViewChild("uapStateTmpl") uapStateTmpl: TemplateRef<void>;
  // 预览操作模板
  @ViewChild("previewActionTmpl") previewActionTmpl: TemplateRef<void>;
  // 预览操作模板
  @ViewChild("previewDateTmpl") previewDateTmpl: TemplateRef<void>;
  // 上传操作模板
  @ViewChild("uploadFileNameTmpl") uploadFileNameTmpl: TemplateRef<void>;
  /**
   * 每个组可以设置特殊服务参数，来覆盖默认的统一模块级配置
   */
  @Input()
  set extendServerConfig(config: any) {
    if (config) {
      this.fileUploaderSer.setExtendServerConfig(config);
    }
  }
  // 内容区域填充
  @Input() contentFill = false;
  /** 启用手动调整展示顺序 */
  @Input() enableOrder = false;
  /** 排序字段 */
  @Input() orderField = "order";
  /** 是否允许编辑文档，默认为 false */
  @Input() editfile: FileCanEditable = false;
  /**列是否支持拖拽 */
  @Input() columnResizable = false;
  @ViewChild('resizeProxy') resizeProxy: ElementRef;
  @ViewChild('resizeProxyBg') resizeProxyBg: ElementRef;
  // 指定拖拽后的最小宽度，剩余其他列的最小宽度
  resizeMinWidth = 50;
  private resizeColumnInfo = {
    proxyLineEdge: 0,
    startWidth: 0,
    startX: 0,
    left: 0,
    scrollLeft: 0
  };
  // doc文档打开模式，预设3种模式，默认normal
  private _docMode = DocModeType.Normal;
  @Input()
  set docMode(value) {
    switch (value) {
      case DocModeType.Normal:
      case DocModeType.Admin:
      case DocModeType.RevisionOnly:
        this._docMode = value;
        break;
      default:
        this._docMode = DocModeType.Normal;
    }
  }
  get docMode() {
    return this._docMode;
  }
  private _renameFromDialog = "";
  // 记录列字段
  private _previewColumnsFields = [];
  /**
   * 预置列信息
   * 调整：
   * 1、把列上的checkbox属性去掉，改为只有启用批量选择时，第一列才会有多选，不允许其他列有多选
   * 2、解决field重名问题，通过判断是否extend=true来判断，是否是自定义列，如果是自定义列，不使用默认的模版
   */
  private _presetPreviewColumns: Array<ColumnData> = [
    { field: "name", width: 200, title: "文件名" },
    { field: "size", width: 100, title: "大小" },
    { field: "createTime", width: 100, title: "日期" },
    { field: "state", width: 100, title: "状态" },
    { field: "action", width: 120, title: "操作" },
  ];
  // 内部记录列信息,与命令构件约定
  private _previewColumns = [];
  @Input()
  set previewColumns(value) {
    if (value) {
      this._previewColumns = [...value];
    } else {
      this._presetPreviewColumns = [...this._presetPreviewColumns];
    }
    this.getFieldsFromColumns();
    this.resizeColumnWidth();
  }
  get previewColumns() {
    return this._previewColumns;
  }
  // 格式化预览数据
  private _fileInfos: FUploadFileExtend[] = [];
  // 处理扩展数据 数组
  @Input() extendInfos;

  @Input()
  set fileInfos(val: FUploadFileExtend[]) {
    this._fileInfos = this.formatPreviewDatas(val);
    if(this.pagination){
      this.pageTotal= this._fileInfos.length;
    }
    this._renameFromDialog = "";
  }
  get fileInfos(): FUploadFileExtend[] {
    return this._fileInfos;
  }
  /**
   * 附件预览配置---------------------------------------开始
   */
  @Input() previewDateFormat = "yyyy-MM-dd";
  // 只读的状态，控制附件是否可删除
  // 默认处于查看状态
  @Input() previewReadonly = true;

  @Input() previewVisible = true;
  // 是否启用批量操作
  @Input() previewEnableMulti = true;
  // 预览显示类别
  @Input() previewShowType = "list";
  // 启用重命名
  @Input() previewEnableRename = true;
  // 默认重命名
  @Input() previewDefaultRename = "";
  // 预览是否显示修订记录
  @Input() previewShowComments = false;
  // 预览是否在非模态窗口
  @Input() previewModeless = false;
  // 是否允许预览文件列表
  @Input() enablePreviewFileList = false;
  // 是否显示预览文件列表的按钮
  @Input() showPreviewFileListBtn = false;
  // 附件预览，预览事件
  @Output() filePreviewEvent = new EventEmitter<FUploadFileExtend>();
  @Output() fileListPreviewEvent = new EventEmitter<{ fileInfo: FUploadFileExtend, fileList: Array<FUploadFileExtend>, options: any }>();
  // 附件预览，下载事件，抛出对象给第三方处理
  @Output() fileDownloadEvent = new EventEmitter<{
    fileInfos: FUploadFileExtend[];
    name: string;
  }>();
  // 附件预览，多选事件
  @Output() fPreviewMultiSelectedEvent = new EventEmitter<
    FUploadFileExtend[]
  >();
  // 当前行
  @Output() fSelectedEvent = new EventEmitter<FUploadFileExtend>();
  // 附件预览，删除事件，抛出对象给第三方处理
  @Output() fileRemoveEvent = new EventEmitter<FUploadFileExtend[]>();
  // 全选状态
  previewSelectAllBtnChecked = false;
  checkAllIndeterminate = false;
  // 记录选中数据
  previewMultiSelected: FUploadFileExtend[] = [];
  // 记录当前行数据
  previewCurrent: string = "";
  // 构造预览的配置数据
  get previewSettings() {
    return {
      readonly: this.previewReadonly,
      visible: this.previewVisible,
      enableMulti: this.previewEnableMulti,
      enableRename: this.previewEnableRename,
    };
  }

  /**
   * 下载或者删除的状态，应用在如下场景
   * 比如：只要允许下载或者删除，就可以显示多选框
   */
  get downloadOrDeleteState() {
    //删除没有单独控制的时候跟着下载的状态走
    if (this.noDelete == 'default') return !this.noDownload;
    return !this.noDownload || !this.noDelete;
  }
  /**
   * 附件预览配置---------------------------------------结束
   */

  /**
   * 附件上传配置---------------------------------------开始
   */
  // 附件上传选择指令
  @ViewChild(FFileSelectDirective) fileUpload: FFileSelectDirective;
  // 附件上传部分禁用状态
  @Input() uploadDisabled = false;
  private tUploadVisible = true;

  // 附件上传部分是否可见
  @Input()
  set uploadVisible(value) {
    this.tUploadVisible = value;
    if (!value) {
      this.uploadReset();
    }
  }
  get uploadVisible() {
    return this.tUploadVisible;
  }
  // 需要重置,通过不断的赋值来改变
  @Input() uploadNeedReset: Observable<any> = new Subject();
  // 启用选择文件按钮
  @Input() uploadEnableSelect = true;
  // 选择文件按钮上传问题
  @Input() uploadSelectText = "上传附件";
  // 启用多选
  @Input() uploadEnableMulti = true;
  // 已经上传文件
  @Input() uploadedCount = 0;
  // 公共的扩展数据
  @Input() extendDatas: {
    [key: string]: any;
    extProperty?: DocMetaProperty | null; //
  };

  /** 整个控件禁用 */
  @Input() disabled = false;
  /** 禁止下载 */
  @Input() noDownload = false;
  /** 禁止预览 */
  @Input() noPreview = false;
  /**禁止删除,约定default是默认，按照noDownload的状态走 */
  @Input() noDelete = 'default';
  /**
   * 是否内部排序
   * 目的：命令构件会根据新指令指定字段进行排序，不需要进行内部排序。为了区分内外排序。
   */
  @Input() enableSorting = true;

  @Input()
  set uploadOptions(uploadOpts: UploaderOptions) {
    if (uploadOpts) {
      if (uploadOpts.hasOwnProperty("allowedContentTypes")) {
        this.allowedContentTypes = uploadOpts.allowedContentTypes.join(",");
        this.allowedContentTypes =
          this.allowedContentTypes == "" ? "*" : this.allowedContentTypes;
      }
      if (uploadOpts.hasOwnProperty("maxUploads")) {
        this.maxUploads = uploadOpts.maxUploads;
      }
      if (uploadOpts.hasOwnProperty("maxFileSize")) {
        this.maxFileSize = FFileUtils.humanizeBytes(
          1024 * 1024 * uploadOpts.maxFileSize
        );
      }
      if (uploadOpts.hasOwnProperty("notAllowedCharsInFileName")) {
        let tNotAllowed = uploadOpts['notAllowedCharsInFileName'];
        this.notAllowedCharsInFileName = tNotAllowed && tNotAllowed.length > 0 ? [...tNotAllowed] : [];
      }
      this.selfUploadOpts = Object.assign(this.selfUploadOpts, uploadOpts);
    }
  }
  get uploadOptions() {
    return this.selfUploadOpts;
  }
  ButtonDisabledAction = ButtonDisabledAction;
  // 添加订阅缓存
  private buttonDisabledStateSubs = new Map<string, Subscription>();
  // 按钮禁用状态缓存
  private buttonDisabledStateCache = new Map<string, boolean>();
  private buttonDisabledStatePending = new Set<string>();
  private buttonDisabledStateDebounceTimer: any = null;
  /** 禁用按钮状态
   *  ['download' 下载, 'preview' 预览, 'edit' 编辑, 'delete' 删除];
   */
  @Input() buttonDisabledCallback?: (context: { info: any, action: ButtonDisabledAction }) => Observable<boolean> | Boolean;
  /** 启用分块上传 */
  @Input() enableSliceUpload = false;
  /** 分块上传每片大小，单位：M, 默认 1M/块 */
  @Input() chunkSize = 1;
  // 展示用户自定义的信息
  @Input() customInfo: any;
  // 支持分页
  @Input() pagination = false;
  // 显示分页条数
  @Input() showPageList=true;
  // 默认分页条数
  @Input() pageSize = 10;
  // 当前分页
  @Input() pageIndex = 1;
  // 分页条数
  private _pageList = [10, 20, 30, 50,100];
  get pageList() {
      return this._pageList;
  }
  @Input() set pageList(val) {
      this._pageList = val;
      if (this.pager) {
          this.pager.setPageList(val);
      }
  }
  private _pageTotal = 0;
  @Input() set pageTotal(val) {
      if (this._pageTotal !== val) {
          this._pageTotal = val || 0;
          this.paginationOptions = Object.assign(this.paginationOptions || {}, { totalItems: val });
      }
  }
  get pageTotal() {
      return this._pageTotal;
}

  // 附件上传中，上传完成抛出的事件
  @Output() fUploadDoneEvent = new EventEmitter<FUploadFileExtend[]>();
  // 附件上传中，删除附件事件
  @Output() fUploadRemovedEvent = new EventEmitter<FUploadFileExtend[]>();

  /** 文件放下事件 */
  @Output() afterOrdered = new EventEmitter();
  /**附件编辑后数据改变事件 */
  @Output() editorValueChanged = new EventEmitter();

  @ViewChild("uaptb") uploadAndPreviewTbodyRef: ElementRef<any>;
  @ViewChild('pager') pager: PaginationControlsComponent;

  private uploadAndPreviewTableHeader: ElementRef = null;
  private uploadAndPreviewTableHeaderCreated$ = new Subject();
  @ViewChild("uapth") set uploadAndPreviewTheadRef(th: ElementRef) {
    if (th) {
      this.uploadAndPreviewTableHeader = th;
      this.setColumnWidth();
      this.ro.observe(th.nativeElement);
      this.uploadAndPreviewTableHeaderCreated$.next(th);
    } else {
      this.uploadAndPreviewTableHeader = null;
      if (this.ro) {
        this.ro.disconnect();
      }
      this.uploadAndPreviewTableHeaderCreated$.next(null);
    }
  }
  get uploadSettings() {
    return {
      disabled: this.uploadDisabled,
      visible: this.uploadVisible,
      enableMulti: this.uploadEnableMulti,
      extendDatas: this.extendDatas,
    };
  }
  // 允许上传的文件类型
  allowedContentTypes = "*";
  // 默认不限制附件上传个数
  maxUploads = 0;
  // 单位KB，默认是12M
  maxFileSize = "12MB";
  // 记录文件个数
  uploadFiles: UploadOutput[];
  // 附件名称中不允许的字符
  notAllowedCharsInFileName = [];
  // 标记通过选择按钮处理的事件
  uploadSelectInput: EventEmitter<UploadInput>;
  private selfUploadOpts: UploaderOptions = {};

  private ro: ResizeObserver | null = null;

  private localSer: LocaleService = null;

  private dateHlp: DateTimeHelperService;

  tips = {
    download: "下载",
    preview: "预览",
    remove: "删除",
    edit: "编辑",
    notedit: "此类型文件不支持在线编辑",
  };
  // 处理基路径
  perfixStr = '';

  // 监听可点击输入框的事件编辑
  editorEventsSub = null;
  // 分页参数
  public paginationOptions: any = {};
  /**
   *
   * @param el
   * @param uploadAPISer
   * @param fileUploaderSer
   * @param notifyService
   * @param ngZone
   */
  constructor(
    private el: ElementRef,
    private uploadAPISer: FFileUploadAPIService,
    private fileUploaderSer: FFileUploaderService,
    private notifyService: NotifyService,
    private ngZone: NgZone,
    private modalSer: BsModalService,
    private cd: ChangeDetectorRef,
    @Optional() private inject: Injector,
    @Optional() public editorService: FPreviewEditorService,
    @Optional() public render2: Renderer2
  ) {
    if (!Array.prototype.includes) {
      Object.defineProperty(Array.prototype, "includes", {
        value: function (valueToFind, fromIndex) {
          if (this == null) {
            throw new TypeError('"this" is null or not defined');
          }
          var o = Object(this);
          var len = o.length >>> 0;
          if (len === 0) {
            return false;
          }
          var n = fromIndex | 0;
          var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
          function sameValueZero(x, y) {
            return (
              x === y ||
              (typeof x === "number" &&
                typeof y === "number" &&
                isNaN(x) &&
                isNaN(y))
            );
          }
          while (k < len) {
            if (sameValueZero(o[k], valueToFind)) {
              return true;
            }
            k++;
          }
          return false;
        },
      });
    }
    if (this.inject) {
      if (WEBAPI_PREFIX_TOKEN) {
        this.perfixStr = this.inject.get(WEBAPI_PREFIX_TOKEN, '');
      }
    }
    this.uploadFiles = [];
    this.uploadSelectInput = new EventEmitter<UploadInput>();
    // 重置----------可能有问题
    this.uploadNeedReset.subscribe((data) => {
      this.uploadReset();
    });

    this.ro = new ResizeObserver((e) => {
      this.setColumnWidth();
    });
    this.localSer = this.notifyService.localeService;
    FFileUtils.getLocalState(this.localSer);
    this._presetPreviewColumns.forEach((col) => {
      col.title = FFileUtils.getLocalStr(`uploadAndPreview.columns.${col.field}`);
    });
    this.tips.download = FFileUtils.getLocalStr("uploadAndPreview.tips.download");
    this.tips.preview = FFileUtils.getLocalStr("uploadAndPreview.tips.preview");
    this.tips.remove = FFileUtils.getLocalStr("uploadAndPreview.tips.remove");
    this.tips.edit = FFileUtils.getLocalStr("uploadAndPreview.tips.edit");
    this.tips.notedit = FFileUtils.getLocalStr("uploadAndPreview.tips.notedit");
    this.dateHlp = new DateTimeHelperService();
    if (!this.editorService) {
      this.editorService = new FPreviewEditorService();
    }
    this.editorService.setInstance(this);
    this.editorEventsSub = this.editorService.editValueChange.subscribe(data => {
      // 附件预览
      this.editorValueChanged.emit(data);
    });
  }
  ngOnInit() {
    this.paginationOptions = {
      id: 'farris-uploadandpreview-pagination_' + new Date().getTime(),
      itemsPerPage: this.pageSize,
      currentPage: this.pageIndex,
      pageList: this.pageList,
      totalItems: this.pageTotal,
      remote: false
  };
    if (this._previewColumns.length == 0) {
      this.previewColumns = [...this._presetPreviewColumns];
    }

    this.resizeColumnWidth();

  }
  ngAfterViewInit() { }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['pageTotal'] && !changes.pageTotal.isFirstChange()) {
      this.paginationOptions['totalItems'] = this.pageTotal;
      this.paginationOptions = { ...this.paginationOptions };
  }
  if (changes['pageIndex'] && !changes.pageIndex.isFirstChange()) {
      this.paginationOptions['currentPage'] = this.pageIndex;
      this.paginationOptions = { ...this.paginationOptions };
  }

  if (changes['pageSize'] && !changes.pageSize.isFirstChange()) {
      this.paginationOptions['itemsPerPage'] = this.pageSize;
      this.paginationOptions = { ...this.paginationOptions };
  }
    const {
      previewReadonly,
      previewVisible,
      previewEnableMulti,
      previewDefaultRename,
    } = changes;
    if (previewReadonly || previewVisible || previewEnableMulti) {
      this.previewUpdateRefresh();
    }
    if (previewDefaultRename) {
      // 重置预览重命名记录
      this._renameFromDialog = "";
    }
  }
  ngOnDestroy() {
    if (this.editorEventsSub) {
      this.editorEventsSub.unsubscribe();
      this.editorEventsSub = null;
    }
    // 清理缓存
    this.buttonDisabledStateCache.clear();
    // 清理订阅
    this.buttonDisabledStateSubs.forEach(sub => sub.unsubscribe());
    this.buttonDisabledStateSubs.clear();
  }
  /**
   * 选择或取消所有
   * @param ev
   */
  selectOrCancelAllHandler(ev) {
    if (ev["checked"]) {
      // 全选
      this.fileInfos.forEach((item) => {
        item.checked = true;
      });
      this.previewMultiSelected = [...this.fileInfos];
      this.previewSelectAllBtnChecked = true;
    } else {
      // 取消
      this.previewMultiSelected = [];
      this.fileInfos.forEach((item) => {
        item.checked = false;
      });
      this.previewSelectAllBtnChecked = false;
    }
    this.checkAllIndeterminate = false;
    // 抛出多选
    this.fPreviewMultiSelectedEvent.emit(this.previewMultiSelected);
    // 解决附件在丛丛表时，从表处于编辑状态时，勾选附件界面不变更的问题
    this.cd.detectChanges();
  }
  /**
   * 格式化文件大小
   * @param bytes
   */
  formateBytes(bytes) {
    return FFileUtils.humanizeBytes(bytes);
  }
  /**
   * 获取文档类型对应的class
   * @param fileName
   */
  getFileTypeClassName(fileName) {
    let clsName = "ffilepreview--filetype";
    // 如果名称为空
    if (!fileName) {
      return clsName + "-any";
    }
    let lastDotIndex = fileName.lastIndexOf(".");
    let fileSuffix = "";
    if (lastDotIndex > -1) {
      fileSuffix = fileName.substring(lastDotIndex + 1).toLocaleLowerCase();
    }
    switch (fileSuffix) {
      case "pdf":
        clsName += "-pdf";
        break;
      case "jpeg":
      case "jpg":
      case "gif":
      case "svg":
      case "png":
      case "bmp":
        clsName += "-img";
        break;
      case "ppt":
      case "pptx":
        clsName += "-ppt";
        break;
      case "doc":
      case "docx":
        clsName += "-doc";
        break;
      case "xls":
      case "xlsx":
        clsName += "-xls";
        break;
      case "txt":
        clsName += "-txt";
        break;
      case "zip":
        clsName += "-zip";
        break;
      case "wps":
        clsName += "-wps";
        break;
      case "wpt":
        clsName += "-wpt";
        break;
      default:
        clsName += "-any";
    }
    return clsName;
  }
  /**
   * 格式化预览数据
   * @param val
   */
  private formatPreviewDatas(val) {
    if (!val.length || this.previewMultiSelected.length !== val.length) {
      this.previewSelectAllBtnChecked = false;
    }

    let formatValue = val.map((item: FUploadFileExtend) => {
      if (!item.hasOwnProperty("size")) {
        item["size"] = undefined;
      }
      if (!item.hasOwnProperty("createTime")) {
        item["createTime"] = undefined;
      }

      return item;
    });

    if (this.enableOrder && this.orderField) {
      formatValue.sort(this.sortPreviewData(this.orderField));
    } else if (this.enableSorting) {
      formatValue.sort(this.sortPreviewData("createTime"));
    }
    if (this.previewEnableMulti) {
      let newFormatValue = formatValue.map((item: FUploadFileExtend) => {
        item["checked"] =
          !!this.previewMultiSelected.find((n) => n.id === item.id) ||
          this.previewSelectAllBtnChecked;
        return item;
      });
      // 归集已选数据
      // if (this.previewSelectAllBtnChecked) {
      //     this.previewMultiSelected = [...newFormatValue].filter(n => n.checked);
      // } else {
      //     this.previewMultiSelected = [];
      // }
      this.previewMultiSelected = [...newFormatValue].filter((n) => n.checked);
      // 标题栏全选的状态
      this.previewSelectAllBtnChecked = this.previewMultiSelected.length == newFormatValue.length;
      // 标题栏全选的中间状态
      this.checkAllIndeterminate = !this.previewSelectAllBtnChecked && this.previewMultiSelected.length > 0;
      // 返回格式化数据
      return newFormatValue;
    } else {
      return formatValue;
    }
  }

  private getValue(field: string, data: any) {
    if (!data) {
      return "";
    }
    let resultVal = "";
    if (field.indexOf(".") === -1 && data.hasOwnProperty(field)) {
      resultVal = data[field];
    } else {
      resultVal = field.split(".").reduce((obj, key) => {
        if (obj) {
          return obj[key];
        } else {
          return null;
        }
      }, data);
    }
    return resultVal;
  }

  private sortPreviewData(key) {
    const _this = this;
    return (x, y) => {
      // 如果没有这个key属性
      if (!x.hasOwnProperty(key) || x[key] === undefined || x[key] === null) {
        return 1;
      }
      if (!y.hasOwnProperty(key) || y[key] === undefined || y[key] === null) {
        return -1;
      }

      if (_this["orderField"] && key === _this["orderField"]) {
        let a = "";
        let b = "";
        if (key.indexOf(".") > -1) {
          a = _this.getValue(key, x);
          b = _this.getValue(key, y);
        } else {
          a = x[key];
          b = y[key];
        }
        return a > b ? 1 : -1;
      } else {
        var oDate1 = new Date(x[key]);
        var oDate2 = new Date(y[key]);
        return oDate1.getTime() > oDate2.getTime() ? -1 : 1;
      }
    };
  }

  /**
   * 格式化处理数据
   */
  private getFieldsFromColumns() {
    this._previewColumnsFields = this._previewColumns.map(
      (item) => item["field"]
    );
  }
  /**
   * 根据列获取对应的列模板
   * @param columnInfo
   */
  getColumnTemplate(columnInfo, type = "preview") {
    let result;
    if (columnInfo.hasOwnProperty('extend') && columnInfo.extend) {
      return "";
    }
    if (type == "preview") {
      switch (columnInfo["field"]) {
        case "state":
          result = this["uapStateTmpl"];
          break;
        case "name":
          result = this["previewFileNameTmpl"];
          break;
        case "action":
          result = this["previewActionTmpl"];
          break;
        case "size":
          result = this["fileSizeTmpl"];
          break;
        case "createTime":
          result = this["previewDateTmpl"];
          break;
        default:
          result = "";
      }
    } else {
      switch (columnInfo["field"]) {
        case "state":
          result = this["uapStateTmpl"];
          break;
        case "name":
          result = this["uploadFileNameTmpl"];
          break;
        case "size":
          result = this["fileSizeTmpl"];
          break;
        default:
          result = "";
      }
    }
    return result;
  }
  /**
   * 多选变更
   */
  previewMultiSelectChange(ev) {
    let hasInArray = this.previewMultiSelected.findIndex(
      (item) => item["id"] == ev["id"]
    );
    let findInArray = this.fileInfos.findIndex(
      (item) => item["id"] == ev["id"]
    );
    if (findInArray > -1) {
      this.fileInfos[findInArray]["checked"] = ev["checked"];
    }

    if (ev["checked"]) {
      //选入
      if (hasInArray == -1) {
        if (findInArray > -1) {
          this.previewMultiSelected.push(this.fileInfos[findInArray]);
        }

      }
    } else {
      //移出
      if (hasInArray > -1) {
        this.previewMultiSelected.splice(hasInArray, 1);
      }
    }
    // 判断是否全选
    if (this.fileInfos.length > 0) {
      if (this.previewMultiSelected.length == this.fileInfos.length) {
        //都全选
        this.previewSelectAllBtnChecked = true;
      } else {
        // 未全选
        this.previewSelectAllBtnChecked = false;
      }
    }
    this.checkAllIndeterminate = this.previewSelectAllBtnChecked == false && this.previewMultiSelected.length > 0;
    // 只要点击就有当前行 此处肯定有值
    this.fileSelected(null, this.fileInfos[findInArray]);
    // 抛出多选
    this.fPreviewMultiSelectedEvent.emit(this.previewMultiSelected);
    // 解决附件在丛丛表时，从表处于编辑状态时，勾选附件界面不变更的问题
    this.cd.detectChanges();
  }
  /**处理附件上传---------------------------------------------------------开始-- */
  /**
   * 统一触发 附件选择和拖拽附件的事件
   * @param ev
   */
  private inputUploadEventEmit(ev: UploadInput) {
    // 如果文件上传启用
    if (this.uploadEnableSelect) {
      this.uploadSelectInput.emit(ev);
    }
    // this.uploadDragInput.emit(ev);
  }
  /**单个文件上传 */
  startUpload(file: UploadFile): void {
    /**
     * Todo:后续可以从上传区块上取内容进行扩展
     */
    const event: UploadInput = this.uploadAPISer.getAssignAPI(
      "multipartUpload",
      {
        file: file,
        type: this.enableSliceUpload ? 'sliceUpload' : 'multipartUpload',
        data: this.extendDatas,
        chunkSize: this.chunkSize
      }
    );
    this.inputUploadEventEmit(event);
  }
  /**
   * 当主从表切换数据当前行时，
   * 解决刷新时候已勾选数据的问题
   */
  previewUpdateRefresh() {
    this.previewMultiSelected = [];
    this.previewSelectAllBtnChecked = false;
    this.checkAllIndeterminate = false;
    this._renameFromDialog = "";
    this.fileInfos.forEach((item) => {
      item.checked = false;
    });
  }
  // 重置方法
  uploadReset() {
    this.uploadFiles = [];
    // 如果文件上传启用
    if (this.uploadEnableSelect) {
      this.fileUpload && this.fileUpload.reset();
    }
  }

  /**
   * 触发绑定
   */
  triggerFileSelect(ev) {
    ev && ev.stopPropagation();
    // 禁用时
    if (this.uploadDisabled) {
      return false;
    }
    this.fileUpload.elementRef.nativeElement.click();
  }
  /**
   * 选择附件按钮，处理抛出事件
   * @param output
   */
  selectUploadOutput(output: UploadOutput): void {
    this.uploadOutputHandler(output);
  }
  /**
   * allAddedToQueue 选中文件追加到队列
   * @param output
   */
  private uploadOutputHandler(output: UploadOutput): void {
    if (output.type === "addedToQueue" && typeof output.file !== "undefined") {
      this.uploadFiles.push({ type: output.type, file: output.file });
      // 开始上传
      this.startUpload(output.file);
    } else if (output.type === "start") {
      // 开始上传
      this.updateFilesState(output, "");
    } else if (output.type == "done") {
      // 上传完成
      this.updateFilesState(output, "done");
      this.fUploadDoneEvent.emit(
        FFileUtils.changeUploadFileToFileExtend(output.files)
      );

      const newAddFiles = output.files.map((n) => {
        return {
          checked: false,
          id: n.id,
          name: n.name,
          size: n.size,
          createTime: this.dateHlp.formatTo(new Date(), "yyyy-MM-dd HH:mm:ss"),
        };
      });

      this.fileInfos = [...newAddFiles, ...this.fileInfos];

      // 上传完成后不在当前页面上显示
      this.hideAfterLoaded(output);
    } else if (
      output.type === "cancelled" ||
      output.type === "removed" ||
      output.type == "error"
    ) {
      // 删除或者移除文件
      this.uploadFiles = this.uploadFiles.filter((fileOutput: UploadOutput) => {
        return (
          output.files.findIndex((item) => fileOutput.file.id == item.id) < 0
        );
      });
      // 给出提示
      this.showNotify(output);
    } else if (
      output.type === "rejected" &&
      typeof output.file !== "undefined"
    ) {
      // 上传被拒绝
      this.showNotify(output);
    }
  }
  /**
   * 临时删除附件
   * @param output
   */
  private hideAfterLoaded(output: UploadOutput): void {
    // 删除或者移除文件
    let ids = output.files.map((fileItem) => fileItem.id);
    this.uploadFiles = this.uploadFiles.filter((fileOutput: UploadOutput) => {
      let tIndex = ids.findIndex((tId) => tId == fileOutput.file.id);
      return tIndex > -1 ? false : true;
    });
    const event: UploadInput = this.uploadAPISer.getAssignAPI("hide", {
      type: "hide",
      id: ids.join(","),
    });
    this.inputUploadEventEmit(event);
  }
  /**
   * 处理上传
   * @param output
   */
  private showNotify(output) {
    let notifyType = "warning";
    if (output.type == "cancelled" || output.type == "removed") {
      notifyType = "success";
    }
    let message = output.hasOwnProperty("message") ? output["message"] : "";
    this.notifyService[notifyType](<NotifyOptions>{
      msg: message,
      timeout: 3000,
    });
  }
  /**
   * 更新附件的状态
   * @param output
   * @param eventType
   */
  private updateFilesState(output: UploadOutput, eventType) {
    let startFiles = [];
    if (output.hasOwnProperty("files") && output.files.length > 0) {
      // 此处更新界面可能有性能问题
      startFiles = output.files;
    } else if (typeof output.file !== "undefined") {
      startFiles = [output.file];
    }
    eventType = eventType ? eventType : output.type;
    startFiles.map((item) => {
      const index = this.uploadFiles.findIndex(
        (fileOutput) =>
          typeof item !== "undefined" && fileOutput.file.id === item.id
      );
      // 变更状态
      if (index > -1) {
        this.uploadFiles[index] = { type: eventType, file: item };
      }
    });
  }
  /**
   * 是否判断有类型限制
   */
  judgeContentTypeLimit() {
    let tTypes = this.allowedContentTypes.split(",");
    let hasAllIndex = tTypes.findIndex((item) => {
      return item == "*";
    });
    return hasAllIndex == -1;
  }
  /**
   * 判断是否有文件大小的限制
   */
  judegeFileSizeLimit() {
    return this.maxFileSize != "0 Byte";
  }
  /**
   * 获取上传进度
   */
  getUploadProgress(uploadInfo: UploadOutput) {
    if (uploadInfo["type"] == "done") {
      return 100;
    }
    if (uploadInfo["file"]["progress"] && uploadInfo["file"]["progress"]) {
      if (uploadInfo["file"]["progress"]["status"] == UploadStatus.Uploading) {
        let tPercentage = uploadInfo["file"]["progress"]["data"]["percentage"];
        return tPercentage > 5 ? tPercentage : 5;
      }
      return 5;
    }
    return 5;
  }
  /**
   * 处理显示
   * @param ev
   * @param fileInfo
   */
  getUploadFileSizeProgress(uploadInfo: UploadOutput) {
    if (!uploadInfo) {
      return "";
    }
    if (uploadInfo["type"] == "done") {
      return FFileUtils.humanizeBytes(uploadInfo.file.size);
    }
    let tPercentage = 5;
    if (uploadInfo["file"]["progress"] && uploadInfo["file"]["progress"]) {
      if (uploadInfo["file"]["progress"]["status"] == UploadStatus.Uploading) {
        tPercentage = uploadInfo["file"]["progress"]["data"]["percentage"];
        tPercentage = tPercentage > 5 ? tPercentage : 5;
      }
    }
    return (
      FFileUtils.humanizeBytes((uploadInfo.file.size * tPercentage) / 100) +
      "/" +
      FFileUtils.humanizeBytes(uploadInfo.file.size)
    );
  }

  /**
   * 处理附件上传---------------------------------------------------------结束--
   */

  filePreviewBtnClickHandler(ev: Event, fileInfo: FUploadFileExtend) {
    // 页面初始化结束，这些信息应该已经被缓存，此处校验是为了解决手动更改了界面按钮的状态，导致无权限者能操作的问题
    const disablePreviewState = this.getButtonDisabledState(fileInfo, ButtonDisabledAction.Preview);
    if (disablePreviewState) {
      return;
    }
    if (this.enablePreviewFileList) {
      this.fileListPreviewHandler(ev, fileInfo);
    } else {
      this.filePreviewHandler(ev, fileInfo);
    }
  }
  /**
   * 预览
   * @param ev
   * @param fileInfo
   */
  filePreviewHandler(ev: Event, fileInfo: FUploadFileExtend) {
    // 不阻止冒泡，解决的是无法冒泡到底层触发当前行事件
    //ev && ev.stopImmediatePropagation();
    //------------------------------TODO
    if (this.noPreview) {
      return;
    }
    Object.assign(fileInfo, this.getPreviewOptions());
    this.filePreviewEvent.emit(fileInfo);
  }
  fileListPreviewHandler(ev: Event, fileInfo: FUploadFileExtend) {
    // 不阻止冒泡，解决的是无法冒泡到底层触发当前行事件
    // ev && ev.stopImmediatePropagation();
    if (this.noPreview) {
      return;
    }
    this.fileListPreviewEvent.emit({ fileInfo: fileInfo, fileList: this.fileInfos, options: this.getPreviewOptions() });
  }
  private getPreviewOptions() {
    return { showDownload: !this.noDownload, showComments: this.previewShowComments, modeless: this.previewModeless };
  }
  /**
   * 下载
   * @param ev
   * @param fileInfo
   */
  fileDownloadHandler(ev: Event, fileInfo: FUploadFileExtend) {
    const disableDownloadState = this.getButtonDisabledState(fileInfo, ButtonDisabledAction.Download);
    if (!disableDownloadState) {
      this.fileDownloadEvent.emit({ fileInfos: [fileInfo], name: "" });
    }
  }
  /**
   * 删除数据
   * @param ev
   * @param fileInfo
   */
  fileRemoveHandler(ev: Event, fileInfo: FUploadFileExtend) {
    //ev.stopImmediatePropagation();
    const disableRemoveState = this.getButtonDisabledState(fileInfo, ButtonDisabledAction.Delete);
    if (disableRemoveState) {
      return;
    }
    if (fileInfo.checked) {
      this.previewMultiSelected = this.previewMultiSelected.filter(
        (n) => n.id !== fileInfo.id
      );
    }
    this.fileRemoveEvent.emit([fileInfo]);
  }
  /**
   * 批量删除
   * @param ev
   */
  multiFileRemoveHandler(ev: Event) {
    ev.stopImmediatePropagation();
    this.fileRemoveEvent.emit(this.previewMultiSelected);
  }
  multiFilePreviewHandler(ev: Event) {
    ev.stopImmediatePropagation();
    this.fileListPreviewEvent.emit({ fileInfo: this.previewMultiSelected[0], fileList: this.previewMultiSelected, options: this.getPreviewOptions() });
  }
  /**
   * 批量下载
   * @param ev 
   * @returns 
   */
  fileMultiDownloadHandler(ev: Event) {
    ev.stopImmediatePropagation();
    let rename = "";
    if (this.previewMultiSelected.length == 1) {
      this.fileDownloadEvent.emit({
        fileInfos: this.previewMultiSelected,
        name: rename,
      });
      return;
    }
    // 启用了重命名
    if (this.previewEnableRename) {
      let self = this;
      const dlgRef = this.modalSer.show(MultiDownloadInfoComponent, {
        width: 440,
        height: 200,
        showMaxButton: false,
        title: FFileUtils.getLocalStr("uploadAndPreview.downloadTitle"),
        initialState: {
          fileTypeCls: this.getFileTypeClassName(
            self.previewMultiSelected[0].name
          ),
          downloadInfos: self.previewMultiSelected,
          downloadName:
            self._renameFromDialog && !self.previewDefaultRename
              ? self._renameFromDialog
              : self.previewDefaultRename,
        },
        showButtons: true,
        buttons: [
          {
            text: FFileUtils.getLocalStr("uploadAndPreview.cancel"),
            cls: "btn btn-secondary",
            handle: () => {
              dlgRef.close();
            },
          },
          {
            text: FFileUtils.getLocalStr("uploadAndPreview.ok"),
            cls: "btn btn-primary",
            handle: () => {
              const contentRef = dlgRef.content as MultiDownloadInfoComponent;
              rename = contentRef.getDownloadName();
              self.fileDownloadEvent.emit({
                fileInfos: self.previewMultiSelected,
                name: rename,
              });
              dlgRef.close();
            },
          },
        ],
      });
    } else {
      //未启用重命名
      rename = this.getName(this.previewMultiSelected[0]["name"]);
      this.fileDownloadEvent.emit({
        fileInfos: this.previewMultiSelected,
        name: rename,
      });
    }
  }
  private getName(name: string) {
    if (name.lastIndexOf(".") > 0) {
      return name.substring(0, name.lastIndexOf("."));
    }
    return "";
  }
  showPreviewStateColumn(columnInfo) {
    if (
      columnInfo["field"] == "state" &&
      (this.uploadDisabled || !this.uploadVisible || this.noDownload)
    ) {
      return false;
    }
    return true;
  }

  /** 拖拽排序后事件 */
  onOrderFileDrop($event) {
    const { removedIndex, addedIndex, payload } = $event;

    const removedItem = this.fileInfos.splice(removedIndex, 1);
    this.fileInfos.splice(addedIndex, 0, ...removedItem);

    this.cd.detectChanges();

    const newOrderItems = this.fileInfos.map((n) => n.id);
    this.afterOrdered.emit({ data: newOrderItems });
  }

  private setColumnWidth() {

    if (this.uploadAndPreviewTableHeader && this.enableOrder) {
      const tableWidth =
        this.uploadAndPreviewTableHeader.nativeElement.offsetWidth;
      const cols =
        this.uploadAndPreviewTableHeader.nativeElement.querySelectorAll("th");
      const trs =
        this.uploadAndPreviewTbodyRef.nativeElement.querySelectorAll("tr");

      this.uploadAndPreviewTbodyRef.nativeElement.style.flexDirection =
        "column";
      this.uploadAndPreviewTbodyRef.nativeElement.style.display = "flex";
      this.uploadAndPreviewTbodyRef.nativeElement.style.width =
        tableWidth + "px";

      Array.from(trs).forEach((tr: any) => {
        tr.style.width = tableWidth + "px";
        const tds = tr.querySelectorAll("td");
        Array.from(cols).forEach((th: any, index: number) => {
          tds[index].style.width = th.offsetWidth + "px";

          if (index === 0) {
            tds[index].querySelector(
              ".uploadAndpreview--title-container"
            ).style.width = th.offsetWidth - 56 + "px";
          }
        });
      });
    }
  }

  editFileHandler($event, fileInfo: FUploadFileExtend) {
    // console.log($event, fileInfo);
    const disableEditoState = this.getButtonDisabledState(fileInfo, ButtonDisabledAction.Edit);
    if (!disableEditoState) {
      window.open(
        `${this.perfixStr}/platform/runtime/dfs/editpage/index.html?id=${fileInfo.id}&docMode=${this.docMode}`
      );
    }
  }

  canEdit(fileInfo: FUploadFileExtend) {
    if (!fileInfo || !fileInfo.name) {
      return false;
    }
    const editType = [
      "doc",
      "docx",
      "xls",
      "xlsx",
      "ppt",
      "pptx",
      "txt",
      "wps",
      "wpt",
    ];
    const extendName = fileInfo.name
      .substr(fileInfo.name.lastIndexOf(".") + 1)
      .toLowerCase();
    if (extendName) {
      return editType.includes(extendName);
    }

    return false;
  }
  /**
   * 点击当前行
   * @param ev 
   * @param fileInfo 
   */
  fileSelected(ev: Event, fileInfo: FUploadFileExtend) {
    if (ev) {
      ev.stopImmediatePropagation();
      ev.stopPropagation();
    }
    if (!this.previewCurrent || fileInfo.id != this.previewCurrent) {
      this.previewCurrent = fileInfo.id;
      // 抛出当前行数据
      this.fSelectedEvent.emit(fileInfo);
    }
  }
  /**
   * 返回模板上下文
   * @param previewIndex 
   * @param colIndex 
   * @returns 
   */
  getPreviewCtx(previewIndex, colIndex) {
    let curRowData = this.getRowData(previewIndex);
    let columnInfo = this.previewColumns[colIndex];
    let curValue = this.getRealDataValue(previewIndex, columnInfo['field'], curRowData);
    return {
      value: curValue,
      rowData: curRowData,
      settings: this.previewSettings,
      column: columnInfo,
      state: 'preview'
    }
  }
  /**
   * 放回当前行数据
   * @param previewIndex 
   * @returns 
   */
  getRowData(previewIndex) {
    return this.extendInfos && this.extendInfos[previewIndex] ? this.extendInfos[previewIndex] : this.fileInfos[previewIndex];
  }
  /**
   * 获取真正的值
   * @param previewIndex 
   * @param field 
   * @returns 
   */
  getRealDataValue(previewIndex, field, rowData = null) {
    if (!rowData) {
      rowData = this.getRowData(previewIndex);
    }
    if (!field || !rowData) return '';
    let fieldArray = field.split('.');
    if (fieldArray.length == 1) {
      return rowData[fieldArray[0]];
    }
    let curItemVal = rowData;
    for (var k = 0; k < fieldArray.length; k++) {
      curItemVal = curItemVal[fieldArray[k]];
      // 没有值或者没有此属性
      if (curItemVal == null || curItemVal == undefined) {
        break;
      }
    }
    if (k == fieldArray.length) {
      return curItemVal == null || curItemVal == undefined ? "" : curItemVal;
    } else {
      return '';
    }
  }
  /**
   * 解决附件上传更新时，自定义列没有字段值或者是预置列有自定义的情况
   */
  canUpdateSelfColumn(previewIndex, column) {
    let rowData = this.getRowData(previewIndex);
    let field = column['field'];
    if (!field || !rowData) return false;
    let fieldArray = field.split('.');
    // 假定A.B这种字段，只要A字段在，B一定在
    if (rowData.hasOwnProperty(fieldArray[0])) {
      return true;
    }
    return false;
  }
  getEditorService() {
    return this.editorService
  }
  /**
   * 获取列宽度
   * @param column 
   * @returns 
   */
  getColumnWidth(column) {
    if (this.columnResizable) {
      return null;
    }
    // 如果没有启用拖拽宽度
    return { width: column.width ? column.width + 'px' : '100px' };
  }
  /**
   * 
   * @param colIndex 
   * @returns 
   */
  getTheadPadding(colIndex) {
    return this.downloadOrDeleteState ? (colIndex == 0 && this.previewEnableMulti ? this.enableOrder ? 56 : 44 : 10) : 10;
  }
  setAndGetColumnMinWidth(colIndex) {
    // 指派的不合适
    if (!this.previewColumns[colIndex].hasOwnProperty('minWidth') || this.previewColumns[colIndex]['minWidth'] <= 0) {
      const theadPadding = this.getTheadPadding(colIndex);
      const minWidth = theadPadding == 10 ? this.resizeMinWidth : theadPadding + this.resizeMinWidth;
      this.previewColumns[colIndex]['minWidth'] = minWidth;
    }
    return this.previewColumns[colIndex]['minWidth'];
  }
  /**
   * 初始计算
   * 拖拽列按照拖拽后的实际宽度显示，剩余列按照各自宽度比例分配，除去拖拽列宽度之后的剩余宽度
   * 例外：
   * 1、拖拽列的宽度不能小于resizeMinWidth指定的值
   * 2、剩余列
   */
  resizeColumnWidth(resizeBarIndex = -1, newColumnWidth = 0) {
    if (!this.columnResizable) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const theadElement = this.el.nativeElement.querySelector(".uploadAndpreview--table thead");
        if (theadElement) {
          // 启用分页，会有个编号
          let theadWidth = theadElement.getBoundingClientRect().width-(this.pagination?56:0);
          let leftMinWidth = 0;
          const computedWidthColumnIndex = [];
          const computedWidthColumns = [];
          let setTotalWidth = this.previewColumns.reduce((accWidth, currentColumn, currentIndex) => {
            const canShow = this.showPreviewStateColumn(currentColumn);
            if (!canShow) {
              computedWidthColumns.push({});
              return accWidth;
            }
            // 设置拖拽的最小宽度
            const currentMinWidth = this.setAndGetColumnMinWidth(currentIndex);
            if (currentIndex == resizeBarIndex) {
              computedWidthColumns.push({});
              currentColumn.width = newColumnWidth;
              return accWidth;
            }
            computedWidthColumnIndex.push(currentIndex);
            leftMinWidth += currentMinWidth;
            currentColumn.width = currentColumn.width ? currentColumn.width : 100;
            computedWidthColumns.push({ minWidth: currentMinWidth, width: currentColumn.width, realIndex: currentIndex, computedWidth: currentColumn.width });
            return accWidth + currentColumn.width;
          }, 0);


          if (resizeBarIndex > -1) {
            // 计算最小应该剩余的宽度，反推剩余宽度是否合理
            // const leftMinWidth = Number((this.resizeMinWidth * setTotalWidth / minWidth).toFixed(2));
            if (leftMinWidth > theadWidth - newColumnWidth) {
              //剩余宽度不合理，拖拽后元素的的宽度太大了
              this.previewColumns[resizeBarIndex].width = theadWidth - leftMinWidth - 6;
              theadWidth = leftMinWidth + 6;
            } else {
              this.previewColumns[resizeBarIndex].width = newColumnWidth;
              theadWidth = theadWidth - newColumnWidth;
            }
          }

          this.reComputedColumnWidth(computedWidthColumns, computedWidthColumnIndex, setTotalWidth, theadWidth);
          computedWidthColumns.map((currentItem) => {
            if (currentItem['computedWidth']) {
              this.previewColumns[currentItem.realIndex].width = currentItem['computedWidth'];
            }
          });

          this.cd.detectChanges(); // 手动触发变更检测
        }
      }, 10);
    });
  }
  /**
   *  因为每个列的最小宽度可能是不一致的
   * @param computedWidthColumns 
   * @param computedWidthColumnIndex 
   * @param setTotalWidth 
   * @param theadWidth 
   */
  private reComputedColumnWidth(computedWidthColumns, computedWidthColumnIndex, setTotalWidth, theadWidth) {
    const setMinWidthColumnIndex = [];
    let newSetTotalWidth = setTotalWidth;
    let newTheadWidth = theadWidth;
    const newComputedWidthColumnIndex = [];
    computedWidthColumnIndex.map((currentItem) => {
      const currentColumn = computedWidthColumns[currentItem];
      const computedWidth = Number(((currentColumn.width / setTotalWidth) * theadWidth).toFixed(2));
      const currentMinWidth = currentColumn.minWidth || this.resizeMinWidth;
      if (computedWidth < currentMinWidth) {
        setMinWidthColumnIndex.push(currentItem);
        // 小于指定的最小宽度
        newSetTotalWidth = newSetTotalWidth - currentColumn.width;
        newTheadWidth = newTheadWidth - currentMinWidth;
        currentColumn.computedWidth = currentMinWidth;
      } else {
        newComputedWidthColumnIndex.push(currentItem);
        currentColumn.computedWidth = computedWidth;
      }
    });
    if (setMinWidthColumnIndex.length > 0) {
      this.reComputedColumnWidth(computedWidthColumns, newComputedWidthColumnIndex, newSetTotalWidth, newTheadWidth);
    }
  }

  private getResizeProxyPosLeft(e: MouseEvent) {
    const target = e.target as any;
    const contentContainer = this.el.nativeElement.querySelector('.uploadAndpreview--content');
    const dgRect = contentContainer.getBoundingClientRect();
    const td = target.parentElement;
    const tdLeft = td.getBoundingClientRect().left;
    const deltaEdge = td.offsetWidth - (e.pageX - tdLeft);
    this.resizeColumnInfo.proxyLineEdge = deltaEdge;
    this.resizeColumnInfo.startWidth = td.offsetWidth;
    this.resizeColumnInfo.startX = e.pageX;
    this.resizeColumnInfo.scrollLeft = contentContainer.scrollLeft;
    // 这个left不包括滚动
    this.resizeColumnInfo.left = tdLeft - dgRect.left - 1 + deltaEdge;
    return e.pageX - dgRect.left - 1 + deltaEdge;
  }

  private toggleResizeProxy(show = true) {
    if (!this.render2) { return; }
    let display = 'block';
    if (!show) {
      display = 'none';
    }
    this.render2.setStyle(this.resizeProxyBg.nativeElement, 'display', display);
    this.render2.setStyle(this.resizeProxy.nativeElement, 'display', display);
  }
  /**
   * 开始拖拽
   * @param e 
   */
  onColumnResizeBegin(e: MouseEvent) {
    if (this.resizeProxy && this.render2) {
      this.render2.setStyle(document.body, 'cursor', 'e-resize');
      const proxy = this.resizeProxy.nativeElement;
      const proxyPosLeft = this.getResizeProxyPosLeft(e);
      this.render2.setStyle(proxy, 'left', proxyPosLeft + this.resizeColumnInfo.scrollLeft + 'px');
      this.toggleResizeProxy();
    }
  }
  onColumnResize(eventInfo) {
    const { event, index } = eventInfo;
    event.stopPropagation();
    event.preventDefault();
    if (!this.render2) { return; }
    const proxy = this.resizeProxy.nativeElement;
    const dgRect = this.el.nativeElement.querySelector('.uploadAndpreview--content').getBoundingClientRect();
    const proxyPosLeft = event.pageX - dgRect.left - 1 + this.resizeColumnInfo.proxyLineEdge;
    let minWidth = this.previewColumns[index].minWidth || this.resizeMinWidth;
    if (proxyPosLeft - this.resizeColumnInfo.left > minWidth) {
      this.render2.setStyle(proxy, 'left', proxyPosLeft + this.resizeColumnInfo.scrollLeft + 'px');
    } else {
      this.render2.setStyle(proxy, 'left', (this.resizeColumnInfo.left + this.resizeColumnInfo.scrollLeft + minWidth) + 'px');
    }
  }
  onColumnResizeEnd(eventInfo) {
    if (!this.render2) { return; }
    const { event, index } = eventInfo;
    this.render2.removeStyle(document.body, 'cursor');
    this.toggleResizeProxy(false);
    this.resizeColumnInfo.proxyLineEdge = 0;

    let newColWidth = this.resizeColumnInfo.startWidth + event.pageX - this.resizeColumnInfo.startX;
    let minWidth = this.previewColumns[index].minWidth || this.resizeMinWidth;
    if (newColWidth < minWidth) {
      newColWidth = minWidth;
    }

    // if (col.width > newColWidth) {
    //     const t = col.width - newColWidth;
    //     if (!this.fitColumns && this.scrollInstance.elementRef.nativeElement.scrollLeft) {
    //         const moveLeft = this.scrollInstance.elementRef.nativeElement.scrollLeft - t;
    //         this.scrollInstance.scrollToX(moveLeft);
    //     }
    // }
    //this.previewColumns[index].width = newColWidth;
    this.resizeColumnWidth(index, newColWidth);
  }
  /**
 * 获取按钮禁用状态
 * @param previewInfo 文件信息
 * @param actionType 操作类型 (download/preview/edit/delete)
 */
  getButtonDisabledState(previewInfo: any, actionType: ButtonDisabledAction): boolean {
    const cacheKey = `${previewInfo.id}-${actionType}`;

    if (this.buttonDisabledCallback) {
      // 优先返回缓存状态
      if (this.buttonDisabledStateCache.has(cacheKey)) {
        return this.buttonDisabledStateCache.get(cacheKey);
      }
      if (!this.buttonDisabledStateSubs.has(cacheKey)) {
        this.buttonDisabledStatePending.add(cacheKey);

        const result = this.buttonDisabledCallback({ info: previewInfo, action: actionType });
        if (result && typeof (result as Observable<boolean>).subscribe === 'function') {
          const sub = (result as Observable<boolean>).pipe(take(1)).subscribe(disabled => {
            this.buttonDisabledStateCache.set(cacheKey, disabled);
            this.buttonDisabledStateSubs.delete(cacheKey);
            this.buttonDisabledStatePending.delete(cacheKey);
            // 防抖批量触发变更检测
            this.scheduleButtonStateUpdate();
          });
          this.buttonDisabledStateSubs.set(cacheKey, sub);
        } else {
          const boolResult = result as boolean;
          this.buttonDisabledStateCache.set(cacheKey, boolResult);
          return boolResult;
        }
      }
      return false;
    }
    return false;
  }
  // 防抖批量更新
  private scheduleButtonStateUpdate(): void {
    if (this.buttonDisabledStateDebounceTimer) {
      clearTimeout(this.buttonDisabledStateDebounceTimer);
    }
    this.buttonDisabledStateDebounceTimer = setTimeout(() => {
      if (this.buttonDisabledStatePending.size === 0) {
        this.cd.detectChanges();
      }
    }, 50);
  }
  /**
   * 手动刷新按钮状态---此处应该用不到，切换用户会刷新界面，不用单独调用
   * @param previewInfo 可选，指定文件，不传则刷新所有
   * @param actionType 可选，指定操作类型，不传则刷新所有操作
   */
  refreshButtonState(previewInfo?: any, actionType?: string): void {
    if (previewInfo) {
      // 刷新指定文件的指定操作
      if (actionType) {
        const cacheKey = `${previewInfo.id}-${actionType}`;
        this.buttonDisabledStateCache.delete(cacheKey);
      } else {
        // 刷新指定文件的所有操作
        const actions = ['download', 'preview', 'edit', 'delete'];
        actions.forEach(action => {
          const cacheKey = `${previewInfo.id}-${action}`;
          this.buttonDisabledStateCache.delete(cacheKey);
        });
      }
    } else {
      // 刷新所有缓存
      this.buttonDisabledStateCache.clear();
    }

    // 触发视图更新
    this.cd.detectChanges();
  }
  
  gotoScrollTop() { 
    const contentContainer = this.el.nativeElement.querySelector('.uploadAndpreview--content');
    contentContainer.scrollTop = 0;
  }
   /**
     * 页码改变
     * @param page 
     */
    onPageChange(page: { pageIndex: number, pageSize: number }) {
      if (this.pageIndex !== page.pageIndex) {
          this.pageIndex = page.pageIndex;
          this.paginationOptions.currentPage = page.pageIndex;
          this.paginationOptions = {...this.paginationOptions};
          // this.pageChanged.emit({ pageInfo: page });
          // 滚动到顶部
          this.gotoScrollTop();
      }
  }
    /**
     * 改变分页大小
     * @param pageSize 
     */
    onPageSizeChange(pageSize: number) {
        // console.log(this.pageSize !== pageSize && this.total);
        if (this.pageSize !== pageSize && this.pageTotal) {
            this.paginationOptions.itemsPerPage = pageSize;
            this.pageSize = pageSize;

            const total = this.pageTotal;
            let pageLength = Math.floor(total / pageSize);
            if (total % pageSize > 0) {
                pageLength += 1;
            }

            if (pageLength && this.pageIndex > pageLength) {
                this.pageIndex = pageLength;
                this.paginationOptions.currentPage = this.pageIndex;
            }
            this.paginationOptions = {...this.paginationOptions};            
            // this.pageSizeChanged.emit({ pageInfo: { pageIndex: this.pageIndex, pageSize } });
            // 滚动到顶部
            this.gotoScrollTop();
        }
    }
    getPageIndex(curPreviewIndex: number) {
      return (this.pageIndex-1)*this.pageSize+curPreviewIndex+1;
    }
}
